import { ca } from '@cian/analytics';

import { toAnalyticsObjectType } from './toAnalyticsObjectType';

export function trackBuildRouteClick(infrastructureType?: string) {
  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: 'route_button',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        object_type: toAnalyticsObjectType(infrastructureType),
      },
    },
    useLastProducts: true,
  });
}
